import React from 'react';
import { CalculatorContextType } from 'contexts/CalculatorContext/types';

export * from './types';
export * from './Provider';
export * from './useCalculator';

export const CalculatorContext = React.createContext<CalculatorContextType>({} as CalculatorContextType);
